import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { EditValueDialogData } from '../../models/form-dialog-data';
import { OBSERVATION_TOOL_EDIT_NOTES_FULLSCREEN_ID } from 'src/app/roles/_shared-by-role/observation-tool/observation-tool.constants';

@Component({
  standalone: false,
  selector: 'app-edit-value-dialog',
  templateUrl: './edit-value-dialog.component.html',
})
export class EditValueDialog {

  isFullScreenAllowed: boolean = false;
  readonly fullScreenId = OBSERVATION_TOOL_EDIT_NOTES_FULLSCREEN_ID;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EditValueDialogData,
    private dialogRef: MatDialogRef<EditValueDialog>
  ) {
    this.isFullScreenAllowed = data.isFullScreenAllowed ?? false;
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.data.onConfirm?.();
    this.dialogRef.close();
  }
}
